import { connect } from 'react-redux';
import { setReleaseMetricsInfo } from './../actions';
import {
  getReleaseMetricsJobsByBuildId,
  getShowOnReleaseMetricsScanImages,
  releaseMetricsPageReducer
} from './../reducers';
import ReleaseMetricsSelectorComponent
  from './../Components/ReleaseMetricsSelectorComponent';
import {
  build as buildHelpers,
  jobNames,
  params,
  utils
} from '../helpers';
import { keys } from 'lodash';

export const getReleaseVersionMemoJobName = (product) => {
  switch (product) {
    case buildHelpers.PRODUCTS.EXAMINE:
      return jobNames.PERFORMANCE;
    case buildHelpers.PRODUCTS.IEF_ENGINE:
      return jobNames.CASE_METRICS;
    case buildHelpers.PRODUCTS.PROCESS:
      return jobNames.CASE_METRICS;
    default:
      return null;
  }
};

export const mapStateToProps = (state) => {
  const releaseInfo = releaseMetricsPageReducer.getReleaseMetricsInfo(state);
  const relevantJobsByVersion = getReleaseMetricsJobsByBuildId(state)({
    jobName: getReleaseVersionMemoJobName(releaseInfo.product),
    product: releaseInfo.product
  });
  const scenarios = getShowOnReleaseMetricsScanImages(state);

  return {
    releaseMetricsInfo: releaseInfo,
    availableScenarios: scenarios || [],
    availableCases: [params.BIGSHINYHITS, params.REALDATA4], // also temp hardcoding
    availableVersions: relevantJobsByVersion ?
      keys(relevantJobsByVersion).sort((a, b) => utils.versionComparer(a, b)) :
      []
  };
};

export const mapDispatchToProps = (dispatch) => {
  return { onSelectorChange: (info) => dispatch(setReleaseMetricsInfo(info)) };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReleaseMetricsSelectorComponent);



// WEBPACK FOOTER //
// src/Containers/ReleaseMetricsSelectorContainer.jsx